import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { EASE } from "./motion";

const QUOTES = [
  {
    text: "FAM filled three senior engineering roles in under a month. The shortlist quality was unlike anything we'd seen from other agencies.",
    name: "Priya Raghavan",
    role: "VP Engineering, TechNova Solutions",
    img: "https://images.pexels.com/photos/34381971/pexels-photo-34381971.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    text: "They rewrote my resume, coached me through four interview rounds, and I landed a 40% hike. It felt like having a career team in my corner.",
    name: "Arjun Mehta",
    role: "Financial Analyst, Meridian Capital",
    img: "https://images.unsplash.com/photo-1767175620484-1ed37931a0d1?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    text: "From temporary staffing to a full executive search, FAM has been our only recruitment call for six years running.",
    name: "Sandra D'Souza",
    role: "CHRO, CareFirst Hospitals",
    img: "https://images.pexels.com/photos/1313534/pexels-photo-1313534.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export default function Testimonials() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % QUOTES.length), 6000);
    return () => clearInterval(t);
  }, []);

  const q = QUOTES[index];

  return (
    <section className="bg-white py-28 md:py-40 px-6 md:px-12 lg:px-24" data-testid="testimonials-section">
      <div className="max-w-4xl mx-auto text-center">
        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.7, ease: EASE }}
          >
            <p className="font-display font-medium text-3xl md:text-4xl lg:text-5xl tracking-tight leading-tight text-[#0A1128]" data-testid="testimonial-quote">
              "{q.text}"
            </p>
            <div className="mt-12 flex items-center justify-center gap-4">
              <img src={q.img} alt={q.name} className="w-14 h-14 object-cover grayscale" />
              <div className="text-left">
                <p className="font-display font-bold text-[#0A1128]" data-testid="testimonial-name">{q.name}</p>
                <p className="text-xs uppercase tracking-[0.2em] text-[#475569]">{q.role}</p>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>

        <div className="mt-12 flex justify-center gap-3" data-testid="testimonial-dots">
          {QUOTES.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              className={`h-1 transition-all duration-500 ${i === index ? "w-10 bg-[#1D4ED8]" : "w-4 bg-[#0A1128]/15"}`}
              data-testid={`testimonial-dot-${i}`}
              aria-label={`Testimonial ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
